export default __webpack_public_path__ + "static/media/777.7efa5c15.png";